export const TABLE_ROWS_PER_PAGE = 50;
export const MAX_MONTHS_TO_SHOW_IN_MONTH_SELECTOR = 61;
